import React from 'react';

import { connect, useSelector } from 'react-redux';
import { isSubscriber as isSubscriberSelector } from '../../selectors/auth';
import { withRouter } from 'react-router-dom';

//Simple bar
import SimpleBar from 'simplebar-react';

import SidebarContent from './SidebarContent';

const Sidebar = (props) => {
  const isSubscriber = useSelector(isSubscriberSelector);

  if (isSubscriber) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div data-simplebar className="h-100">
          {props.type !== 'condensed' ? (
            <SimpleBar style={{ maxHeight: '100%' }}>
              <SidebarContent />
            </SimpleBar>
          ) : (
            <SidebarContent />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};
export default connect(mapStatetoProps, {})(withRouter(Sidebar));
